import {getFeatureFlag} from '@/feature-flags/feature-flags-store';
import {loadProductJson} from '@/product/product-selection/load-product-json';
import {h} from 'preact';
import register from 'preact-custom-element';
import SingleStepBuyStack from './SingleStepBuyStack';

export enum BuyStackVariant {
  SingleStep = 'single-step',
  SingleStepOtp = 'single-step-otp',
  SingleStepLoads = 'single-step-loads',
}

type SingleStepBuyStackLoaderProps = {
  product: string;
  title?: string;
  buyStackVariant: BuyStackVariant;
};

register(SingleStepBuyStackLoader, 'single-step-buy-stack', [
  'product',
  'settings',
  'buy-stack-variant',
]);

function SingleStepBuyStackLoader({
  product,
  title,
  buyStackVariant,
}: SingleStepBuyStackLoaderProps) {
  loadProductJson(product);

  return h(SingleStepBuyStack, {
    buyStackVariant: buyStackVariant || getActiveFeatureVariant(),
    title,
  });
}

/**
 * Selects the buy stack variant to use based on the provided props.
 * If the buy stack variant is provided, it will be used.
 * Otherwise, feature flags are used to determine the variant.
 * @returns The selected buy stack variant.
 */
function getActiveFeatureVariant(): BuyStackVariant {
  const featureFlags = {
    [BuyStackVariant.SingleStep]: getFeatureFlag('single-step'),
    [BuyStackVariant.SingleStepOtp]: getFeatureFlag('single-step-otp'),
    [BuyStackVariant.SingleStepLoads]: getFeatureFlag('single-step-loads'),
  };

  return (
    (Object.keys(featureFlags).find(
      (key) => featureFlags[key as BuyStackVariant] === 'true'
    ) as BuyStackVariant) || BuyStackVariant.SingleStepLoads
  );
}
